export default __webpack_public_path__ + "static/media/sportsbra-large-front-toobig.37735aeb.jpg";